// extracted by mini-css-extract-plugin
export default {"loginForm":"Login_loginForm__1kk93","loginForm__remember":"Login_loginForm__remember__3qfVk","loginForm__submit":"Login_loginForm__submit__fmAKm","input":"Login_input__SXjTA"};